import React, { useEffect, useState } from "react";

export default function AdminDashboard() {
  const [data, setData] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    fetch("/api/admin/secret", { credentials: "include" })
      .then(res => res.json())
      .then(setData)
      .catch(() => setError("Failed to load admin data"));
  }, []);

  return (
    <div>
      <h2>Admin Dashboard</h2>
      {error && <p className="error">{error}</p>}
      {data && <pre>{JSON.stringify(data, null, 2)}</pre>}
    </div>
  );
}
